import { LOCAL_CONFIG } from './local';
import { STAGING_CONFIG } from './staging';
import { PROD_CONFIG } from './prod';
export var CONFIG = ('local' === process.env.MIX_CONFIG_ENV ? LOCAL_CONFIG : ('staging' === process.env.MIX_CONFIG_ENV ? STAGING_CONFIG : PROD_CONFIG));
